import React, { useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: '¿En qué formato lo recibo?',
    answer: 'PDF de alta resolución, descarga inmediata.'
  }, {
    question: '¿Cuántas veces puedo imprimirlo?',
    answer: 'Las veces que quieras, para siempre.'
  }, {
    question: '¿Para qué edades funciona mejor?',
    answer: 'Está diseñado progresivamente de 2 a 6 años.'
  }, {
    question: '¿Necesito impresora especial?',
    answer: 'No, funciona con cualquier impresora estándar en carta o A4.'
  }, {
    question: 'Is it really bilingual?',
    answer: 'Yes! Every activity has instructions in Spanish and English.'
  }];
  return <section ref={ref} className="w-full bg-white py-16 md:py-20" data-id="element-40">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-41">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} className="font-fredoka text-3xl sm:text-4xl font-bold text-gray-900 text-center mb-12" data-id="element-42">
          Preguntas Frecuentes / FAQ
        </motion.h2>

        <div className="space-y-4" data-id="element-43">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          delay: 0.1 * index,
          duration: 0.4
        }} className="bg-orange-50 rounded-2xl overflow-hidden shadow-md" data-id="element-44">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-orange-100 transition-colors" data-id="element-45">
                <span className="font-fredoka text-lg font-bold text-gray-900 pr-4" data-id="element-46">
                  ❓ {faq.question}
                </span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.3
            }} data-id="element-47">
                  <ChevronDown className="w-6 h-6 text-orange-600 flex-shrink-0" data-id="element-48" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-49">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-50">
                    <div className="px-6 pb-6" data-id="element-51">
                      <p className="font-nunito text-base text-gray-700 leading-relaxed" data-id="element-52">
                        → {faq.answer}
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}